import { jsxs as N, jsx as r } from "react/jsx-runtime";
import { useState as O } from "react";
import e from "./submit-booking-number.module.less.js";
import { Input as d } from "../../../../../components/form-elements/input/input.js";
import "react-hook-form";
import "dayjs";
import { useTranslation as n } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { PrimaryButton as c } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import { AlertSummary as R } from "../../../../../components/elements/alert-summary/alert-summary.js";
import "@radix-ui/react-slider";
import { trailerRentalBookingNumber as C } from "../../../../../utilities/validation.js";
const X = ({
  title: T,
  preamble: E,
  isLoading: L,
  bookingNumber: i,
  errorMessageGetBookingNumber: m,
  errorMessageGetCancelBooking: A,
  setBookingNumber: o,
  onSubmit: p
}) => {
  const [a, I] = O(), { t } = n(), l = () => {
    a || I(!0), s(i) && p(i);
  }, s = (_) => _ ? C.test(_) : !1;
  return /* @__PURE__ */ N("div", { className: [e.wrapper, "max-width padded-sides centered"].join(" "), children: [
    /* @__PURE__ */ r("h1", { className: "h2 heading-max-width", children: T || t("TRAILER_RENTAL_CANCELLATION_TITLE") }),
    /* @__PURE__ */ r("p", { className: [e.text, "body-l text-max-width"].join(" "), children: E || t("TRAILER_RENTAL_CANCELLATION_PREAMBLE") }),
    /* @__PURE__ */ N("div", { className: e.inputWrapper, children: [
      /* @__PURE__ */ r(
        d.Text,
        {
          label: t("TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_LABEL"),
          helperText: t("TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_HELPER_TEXT"),
          onChange: (_) => o(_.target.value),
          value: i,
          placeholder: t("TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_PLACEHOLDER"),
          isValid: a && s(i),
          errorText: t("TRAILER_RENTAL_CANCELLATION_BOOKING_NUMBER_INPUT_ERROR_TEXT"),
          className: e.input,
          isRequired: !0
        }
      ),
      /* @__PURE__ */ r(
        c,
        {
          onClick: l,
          label: t(L ? "TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL_LOADING" : "TRAILER_RENTAL_CANCELLATION_GET_BOOKING_BUTTON_LABEL"),
          isLoading: L
        }
      )
    ] }),
    /* @__PURE__ */ N("div", { className: e.errorWrapper, children: [
      m && /* @__PURE__ */ r(R, { type: "error", messages: [m] }),
      A && /* @__PURE__ */ r(R, { type: "error", messages: [A] })
    ] })
  ] });
};
export {
  X as SubmitBookingNumber
};
